export default "__VITE_PUBLIC_ASSET__48bb8336__"